export const initialState = {
  calculation: {},
};

export const returnCalculatorReducer = (state = initialState, action) => {
  console.log("lang & ReturnCalculatorFullState action 33", action.type, action.payload);
  switch (action.type) {
    case "SET_RETURNAL_CALCULATOR":
      return { ...state, calculation: action.payload };
    default:
      return state;
  }
};
